import QuickSelection from "./pages/quickselection"
// import Container from 'react-bootstrap/Container';
import "bootstrap/dist/css/bootstrap.css";
import {
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import Boxloader from "./pages/components/boxloader";
import { useEffect, useState, useContext } from "react";

import i18n from "./i18n";
import StateAmbContextProvider from "./stateContext";


const item = "";

function update_cu_states(type, value){
  console.log("UPDATEING",type,value);
}

function navigate(){
  console.log("Called Navigate")
}

function changeView(){
  console.log("called Change view")
}

function App(props) {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var pathname = url.searchParams.get("pathname");
  const [language,setLanguage] = useState({'lang':"en"})

  function changeLanguage(lang){
    console.log(lang);
    setLanguage({'lang':lang});
    i18n.changeLanguage(lang);

  }
 
  var hold_componenet = <QuickSelection />  ;
  if (pathname==="boxloader"){
    hold_componenet = <Boxloader tool={"quickloader"} update={update_cu_states} ></Boxloader>
  }
  else{
   hold_componenet = <QuickSelection />  
  }
  
  return (
    
      <StateAmbContextProvider >
        <div className="container-fluid">
          <div style={{display:"none"}} ><input
              checked={language.lang === 'en'}
              name="language" onChange={(e) => changeLanguage("en")} value="en" type="radio" />English &nbsp; 
              <input name="language" value="jp" 
              checked={language.lang === 'esp'}
              type="radio" onChange={(e) => changeLanguage("esp")} />Spanish</div>
          
          <Router basename={'/regulatory/quick-selection'} >     
              <Switch>
                {hold_componenet}        
              </Switch>
          </Router>      
            
          </div>
      </StateAmbContextProvider>
  );
}

export default App;
